import { Component, Inject, OnInit } from '@angular/core';
import { DossierService, DossierExportPeriod, DossierExportPeriodType } from '../../domain';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GoogleAnalyticsService } from '../../main-core/google-analytics.service';
import { Dossier } from '../../domain/types/dossier';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

/**
 * Pop-up dialog for exporting documents with provided date range
 */
@Component({
	selector: 'dossier-export-data-modal',
	templateUrl: './dossier-export-data-modal.component.html',
	styleUrls: ['./dossier-export-data-modal.component.scss']
})
export class DossierExportDataModalComponent implements OnInit{
	startDate: Date;
	endDate: Date;
	dossier: Dossier;
	allPeriodType: boolean = true;
	title: string = "Activities to include in the supervisor export";
	exportBtnTxt: string = "Export Selected Years in Word";

	//modal component params
	minDate: Date;
	maxDate: Date;
	userId: string;

	constructor(
		private svc: DossierService,
		private readonly snackbar: MatSnackBar,
		public dialogRef: MatDialogRef<DossierExportDataModalComponent>,
		private gaService: GoogleAnalyticsService,
		@Inject(MAT_DIALOG_DATA) data: any)

	{
		this.dialogRef.disableClose = false;
		this.minDate = data.minDate;
		this.maxDate = data.maxDate;
		this.userId = data.userId;
	}

	ngOnInit(): void {

		this.svc.refreshDossier(); //refresh dossier to update data
		//Set form fields based on Dossier values
		this.allPeriodType = this.svc.dossierPeriod.type == DossierExportPeriodType.All;
		this.startDate = this.svc.dossierPeriod.startDate; 
		this.endDate = this.svc.dossierPeriod.endDate;
    }

	//Downloads specified report type 
	downloadDoc(){
        this.svc.downloadSupervisorDoc((this.userId !== undefined ? this.userId : null))
			.then(r => r.matchDo(
				_ => {
					this.snackbar.open('Dossier Export is downloading');
					this.gaService.eventEmitter("Dossier Export Downloaded", "Dossier Export", "Download");
				},
				errorMessage => this.snackbar.open(errorMessage,null,{duration:5000})
			)
		);
	}
	
	dateChange(type: string, e: MatDatepickerInputEvent<Date>){
		this.allPeriodType = false;
		if (this.startDate !== null && this.endDate !== null){
			const betweenType: DossierExportPeriod = {type: DossierExportPeriodType.Only, startDate: this.startDate, endDate: this.endDate};
			this.svc.dossierPeriod = betweenType; 
		}		
		else if (this.startDate !== null && this.endDate === null){
			const onOrAfter: DossierExportPeriod = {type: DossierExportPeriodType.OnOrAfter, startDate: this.startDate};
			this.svc.dossierPeriod = onOrAfter; 
		}	
		else if (this.startDate === null && this.endDate !== null){
			const onOrBefore: DossierExportPeriod = {type: DossierExportPeriodType.OnOrBefore, endDate: this.endDate};
			this.svc.dossierPeriod = onOrBefore; 
		}		     
	}

	requirementsMet() {
		if(!!this.dossier) {
			if(this.dossier.ExportStatus.InvalidActivityCount > 0 || this.dossier.ExportStatus.InvlidReasonCount > 0) {
				return false;
			}
		}
		return true;
	}

	typeChanged(): void {
		this.startDate = null;
		this.endDate = null;
		if(this.allPeriodType){
			const allType: DossierExportPeriod = {type: DossierExportPeriodType.All};
			this.svc.dossierPeriod = allType;
		} 
	}

	cancel(){
		this.dialogRef.close();
	}
}